import React, { useState } from 'react';
import { Container, FilterContent, FilterInputContainer } from './styles';
import {
  IFabricationOrder,
  EFabricationOrderStatus,
  fabricationOrderStatusMap
} from '../../../../store/ducks/fabrication-orders/types';
import FabricationOrderStatusSelect from './FabricationOrderStatusSelect/indes';
import moment from 'moment';
import { TextField } from '@gerdau/hefesto/TextField';
import { Title } from '@gerdau/hefesto/Title';
import { Button } from '@gerdau/hefesto/Button';
import { useDispatch } from 'react-redux';
import { sendTagging } from '../../../../store/ducks/tagging/actions';

interface IFabricationOrdersFiltersProps {
  orders: IFabricationOrder[];
  setFilteredOrders(filteredOrders: IFabricationOrder[]): void;
  onCleanFilters(): void;
  isAllDisabled: boolean;
}

const FabricationOrdersFilters: React.FC<IFabricationOrdersFiltersProps> = ({
  orders,
  setFilteredOrders,
  onCleanFilters,
  isAllDisabled
}) => {
  const dispatch = useDispatch();

  const [selectedStatusArray, setSelectedStatusArray] = useState<
    EFabricationOrderStatus[]
  >([]);

  const [searchInput, setSearchInput] = useState('');

  const cleanFilters = () => {
    dispatch(
      sendTagging({
        event: 'click',
        itemName: 'button: limpar_filtros',
        itemDescription: `meusPedidos_corteDobra_limparFiltros`,
        screenName: 'LG:MeusPedidos:CorteDobra',
        filterInfo: `#stt:${selectedStatusArray
          .map((status) => fabricationOrderStatusMap.get(status))
          .join(',')}#flt:${searchInput}`
      })
    );
    setSelectedStatusArray([]);
    setSearchInput('');
    onCleanFilters();
  };

  const onFilter = (
    newSearchInputValue: string,
    newStatusArray: EFabricationOrderStatus[]
  ) => {
    const handleFilterByStatus = (
      statusArray: EFabricationOrderStatus[],
      filteredOrders: IFabricationOrder[]
    ) => {
      return filteredOrders.filter((order) => {
        return statusArray.includes(
          order.orderStatus.toString() as EFabricationOrderStatus
        );
      });
    };

    const handleFilterBySearchInput = (
      searchInputValue: string,
      filteredOrders: IFabricationOrder[]
    ) => {
      return filteredOrders.filter((order) => {
        return (
          order.orderNumber.toUpperCase().includes(searchInputValue) ||
          order.contractNumber.toUpperCase().includes(searchInputValue) ||
          moment(order.desiredDate, 'YYYY-MM-DD')
            .format('DD/MM/YYYY')
            .includes(searchInputValue) ||
          moment(order.sendDate, 'YYYY-MM-DD')
            .format('DD/MM/YYYY')
            .includes(searchInputValue) ||
          order.formattedOrderCode.toUpperCase().includes(searchInputValue)
        );
      });
    };
    let newFilteredOrders = orders;

    setSearchInput(newSearchInputValue);
    newFilteredOrders = handleFilterBySearchInput(
      newSearchInputValue.toUpperCase(),
      newFilteredOrders
    );

    setSelectedStatusArray(newStatusArray);
    if (newStatusArray.length > 0) {
      newFilteredOrders = handleFilterByStatus(
        newStatusArray,
        newFilteredOrders
      );
    }

    setFilteredOrders(newFilteredOrders);
  };

  const getAvailableStatusToFilter = (): EFabricationOrderStatus[] => {
    const allStatus: EFabricationOrderStatus[] = [];
    orders.forEach((order) => {
      const orderStatus =
        order.orderStatus.toString() as EFabricationOrderStatus;
      if (!allStatus.includes(orderStatus)) allStatus.push(orderStatus);
    });
    return allStatus;
  };

  return (
    <Container>
      <FilterContent className={isAllDisabled ? 'all-disabled' : ''}>
        <Title level={3}>Filtros</Title>
        <div className="inputs-container">
          <div>
            <FilterInputContainer>
              <FabricationOrderStatusSelect
                disabled={isAllDisabled}
                placeholder="Todos"
                selectedStatus={selectedStatusArray}
                onSelectedStatus={(selectedStatus: EFabricationOrderStatus[]) =>
                  onFilter(searchInput, selectedStatus)
                }
                availableStatusToFilter={getAvailableStatusToFilter()}
              />
            </FilterInputContainer>
          </div>

          <div>
            <FilterInputContainer searchTextField>
              <TextField
                label="Pesquisar"
                name="inputField"
                placeholder="Insira código do pedido, contrato, data de envio ou desejada"
                onChange={(e) => onFilter(e.target.value, selectedStatusArray)}
                helperText="Pesquise pelo código do pedido, contrato, data de envio ou data desejada"
                value={searchInput}
                disabled={isAllDisabled}
              />
            </FilterInputContainer>

            <Button
              name="limpar-filtros"
              disabled={isAllDisabled}
              onClick={cleanFilters}
              variant="tertiary"
            >
              Limpar filtros
            </Button>
          </div>
        </div>
      </FilterContent>
    </Container>
  );
};

export default FabricationOrdersFilters;
